
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school/cloud-computing",
      function () {
        return require("private-next-pages/school/cloud-computing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school/cloud-computing"])
      });
    }
  